import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  input,
  InputSignal,
  signal,
  WritableSignal
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SzIconComponent } from '../../display/sz-icon';

@Component({
  selector: 'sz-checkbox-card',
  templateUrl: './sz-checkbox-card.component.html',
  styleUrls: ['./sz-checkbox-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SzIconComponent],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SzCheckboxCardComponent),
      multi: true
    }
  ]
})
export class SzCheckboxCardComponent implements ControlValueAccessor {
  readonly label: InputSignal<string> = input.required<string>();
  readonly description: InputSignal<string | null> = input<string | null>(null);

  readonly value: WritableSignal<boolean> = signal<boolean>(false);
  readonly disabledState: WritableSignal<boolean> = signal<boolean>(false);

  private onChange: (value: boolean) => void = (): void => {};
  private onTouched: () => void = (): void => {};

  writeValue(value: boolean | null): void {
    this.value.set(value === true);
  }

  registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabledState.set(isDisabled);
  }

  toggle(): void {
    if (this.disabledState()) {
      return;
    }
    const next: boolean = !this.value();
    this.value.set(next);
    this.onChange(next);
    this.onTouched();
  }
}
